import { IController, IWindowService } from 'angular';
import * as _ from 'lodash';
import { SdcWizardStepperService } from './../../../../../shared/services/sdc/sdc-wizard-stepper.service';
import { ISdcStore } from './../../../../flux/sdc-store.interface';

const sdcKey = 'grad-planning';

export class GradPlanningTransferStepperCtrl implements IController {
  static $inject: string[] = ['$mdStepper', '$scope', 'SDCStore', 'SdcWizardStepperService', '$window'];

  public currentFilter: any;
  public hasFilter: boolean;
  public stepper: any;
  private stepperId: string;

  constructor(
    private $mdStepper: any,
    private $scope,
    private SDCStore: ISdcStore,
    private SdcWizardStepperService: SdcWizardStepperService,
    private $window: IWindowService,
  ) {}

  setUi() {
    this.currentFilter = _.last(this.SDCStore.getFilter().cohort);
  }

  setListeners() {
    this.$scope.$listenTo(this.SDCStore, ['filter'], this.setUi.bind(this));
  }

  $onInit(): void {
    this.stepperId = 'grad-planning-transfer-stepper';
    // Stepper must be initialized with active step, etc. after loaded
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.setListeners();
        this.$window.setTimeout(() => this.SdcWizardStepperService.init(sdcKey));
      }
    });
  }

  prevStep = this.SdcWizardStepperService.back;
  nextStep = this.SdcWizardStepperService.next;
}
